import { graphql } from "react-relay";

export const ORDER_FRAGMENT = graphql`
	fragment invoiceEmailActions_OrderFragment on Order {
		id
		status
		customerDetails {
			invoiceEmail
		}
		invoiceData {
			... on CreatedInvoiceData {
				invoiceNumber
			}
		}
	}
`;

export const CORRECT_INVOICE_EMAIL_MUTATION = graphql`
	mutation invoiceEmailActions_CorrectInvoiceEmailMutation($input: CorrectInvoiceEmailInput!) {
		Admin {
			Billing {
				correctInvoiceEmail(input: $input) {
					order {
						id
						customerDetails {
							invoiceEmail
						}
						history {
							...orderHistoryTable_OrderHistoryFragment
						}
					}
					clientMutationId
				}
			}
		}
	}
`;

export const SEND_CLAIM_EMAIL_MUTATION = graphql`
	mutation invoiceEmailActions_SendGuestOrderClaimEmailMutation(
		$input: SendGuestOrderClaimEmailInput!
	) {
		Admin {
			Billing {
				sendGuestOrderClaimEmail(input: $input) {
					sentToInvoiceEmail
					clientMutationId
				}
			}
		}
	}
`;

export const RESEND_INVOICE_MUTATION = graphql`
	mutation invoiceEmailActions_ResendInvoiceMutation($input: ResendInvoiceInput!) {
		Admin {
			Billing {
				resendInvoice(input: $input) {
					sentToInvoiceEmail
					clientMutationId
				}
			}
		}
	}
`;
